import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/Button';
import { Film, User } from 'lucide-react';
export function Header() {
  const {
    isLoggedIn,
    user,
    logout
  } = useAuth();
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  return <header className="sticky top-0 z-10000 w-full bg-[#0a0a0a]/90 backdrop-blur-md border-b border-[#333]" data-id="element-135">
      <div className="container mx-auto px-4 h-20 flex items-center justify-between" data-id="element-136">
        {/* Left: Logo */}
        <div className="flex items-center gap-3" data-id="element-137">
          <Link to="/" className="flex items-center gap-3 group" data-id="element-138">
            <div className="relative" data-id="element-139">
              <div className="absolute inset-0 bg-[#D22B2B] blur-md opacity-20 group-hover:opacity-40 transition-opacity" data-id="element-140"></div>
              <Film className="h-6 w-6 text-[#D22B2B] relative z-10" data-id="element-141" />
            </div>
            <div className="flex flex-col" data-id="element-142">
              <span className="font-noir text-2xl font-bold leading-none tracking-wide text-gray-100 group-hover:text-white transition-colors" data-id="element-143">
                KINOSOVETY
              </span>
              <span className="text-[9px] uppercase tracking-[0.3em] text-[#D22B2B] font-medium ml-0.5" data-id="element-144">
                Noir Collection
              </span>
            </div>
          </Link>
        </div>

        {/* Center: Nav */}
        <nav className="hidden md:flex items-center gap-10" data-id="element-145">
          <Link to="/catalog" className={`text-xs font-serif uppercase tracking-[0.2em] hover:text-[#D22B2B] transition-all duration-300 ${isActive('/catalog') ? 'text-[#D22B2B] drop-shadow-[0_0_8px_rgba(210,43,43,0.5)]' : 'text-gray-400'}`} data-id="element-146">
            Каталог
          </Link>
          <Link to="/search" className={`text-xs font-serif uppercase tracking-[0.2em] hover:text-[#D22B2B] transition-all duration-300 ${isActive('/search') ? 'text-[#D22B2B] drop-shadow-[0_0_8px_rgba(210,43,43,0.5)]' : 'text-gray-400'}`} data-id="element-147">
            Поиск
          </Link>
        </nav>

        {/* Right: Auth */}
        <div className="flex items-center gap-4" data-id="element-148">
          {isLoggedIn ? <div className="flex items-center gap-4" data-id="element-149">
              <Link to="/profile" className="hidden md:block text-xs font-serif uppercase tracking-widest text-gray-300 hover:text-white" data-id="element-150">
                {user?.name}
              </Link>
              <Link to="/profile" data-id="element-151">
                <Button variant="outline" size="sm" className="hidden md:flex border-[#333] hover:border-[#D22B2B]" data-id="element-152">
                  <User className="h-3 w-3 mr-2" data-id="element-153" />
                  Профиль
                </Button>
              </Link>
              <Button variant="ghost" size="sm" onClick={logout} className="md:hidden text-gray-400" data-id="element-154">
                <User className="h-5 w-5" data-id="element-155" />
              </Button>
            </div> : <Link to="/login" data-id="element-156">
              <Button variant="primary" size="sm" className="shadow-[0_0_10px_rgba(210,43,43,0.2)]" data-id="element-157">
                Войти
              </Button>
            </Link>}
        </div>
      </div>
    </header>;
}